import React from "react";
import { Doughnut } from "react-chartjs-2";
import Chart from 'chart.js/auto';

// Register the center text plugin
Chart.register({
  id: 'centerText',
  beforeDraw: function (chart) {
    const width = chart.width;
    const height = chart.height;
    const ctx = chart.ctx;

    ctx.restore();
    const text = chart.options.plugins.centerText.text;
    const color = chart.options.plugins.centerText.color;
    const fontStyle = chart.options.plugins.centerText.fontStyle;
    const fontFamily = chart.options.plugins.centerText.fontFamily;
    const fontSize = chart.options.plugins.centerText.fontSize;

    ctx.font = `${fontStyle} ${fontSize}px ${fontFamily}`;
    ctx.fillStyle = color;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    const textX = width / 2;
    const textY = height / 2;
    ctx.fillText(text, textX, textY);
    ctx.save();
  }
});

const PerformanceDoughnut = React.memo(({ data, style }) => {
  const options = {
    cutout: '70%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      },
      centerText: {
        text: `${(data.datasets[0].data[0]).toFixed(1)}%`,
        color: '#1976d2',
        fontStyle: 'bold',
        fontFamily: 'Arial',
        fontSize: 16
      }
    },
    maintainAspectRatio: false
  };

  return <Doughnut data={data} options={options} style={style} />;
});

export default PerformanceDoughnut; 